module.exports = __webpack_public_path__ + "static/media/terms.8fac9415.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/terms.pdf
// module id = 477
// module chunks = 2